// extracted by mini-css-extract-plugin
export default {"hours":"hours_hours__dgKs2","hoursLine":"hours_hoursLine__yrDR7","time":"hours_time__teWTL"};